<template>
  <div class="home">
    <List></List>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from '@/components/footer.vue'
import List from '@/components/list.vue'

export default {
  name: 'Home',
  components: {
    List,
    Footer
  },
  mounted(){
    document.title = this.$route.meta.title
  }
}
</script>